import Types from './types';
import { createReducer } from 'reduxsauce';

const INITIAL_STATE = {
    total: 0,
    results: [],
    isLoading: false,
};
const orderRequest = (state = INITIAL_STATE) => {
    return {
        ...state,
        isLoading: true
    };
};
const orderResponse = (state = INITIAL_STATE) => {
    return {
        ...state,
        isLoading: false
    };
};
const setOrders = (state = INITIAL_STATE, { data }) => {
    return {
        ...state,
        ...data,
        isLoading: false
    };
};

const HANDLERS = {
    [Types.ORDER_REQUEST]: orderRequest,
    [Types.ORDER_RESPONSE]: orderResponse,
    [Types.SET_ORDERS]: setOrders,
};

export default createReducer(INITIAL_STATE, HANDLERS);